import { JobUserXingApplicationStatus } from '@xing-com/crate-common-graphql-types';
import type { JobDetailsVisibleJobFragment } from '@xing-com/crate-jobs-graphql';

import type { ApplicationData } from './job-details-types';

type JobApplication = Pick<
  JobDetailsVisibleJobFragment,
  | 'application'
  | 'id'
  | 'jobCode'
  | 'prioritized'
  | 'slug'
  | 'title'
  | 'userInteractions'
>;

export const getApplicationData = (job: JobApplication): ApplicationData => {
  const {
    application,
    id,
    jobCode,
    prioritized,
    slug,
    title,
    userInteractions,
  } = job;
  return {
    applyEmail:
      application?.__typename === 'EmailApplication'
        ? (application?.applyEmail ?? undefined)
        : undefined,
    applyUrl:
      application?.__typename === 'UrlApplication'
        ? (application?.applyUrl ?? undefined)
        : undefined,
    code: jobCode ?? undefined,
    contactUserId:
      application?.__typename === 'MessageApplication'
        ? (application.contactUserId ?? undefined)
        : undefined,
    jobId: id,
    prioritized,
    slug,
    status: userInteractions?.application?.status,
    submittedAt:
      userInteractions?.application?.status !==
        JobUserXingApplicationStatus.Error &&
      userInteractions?.application?.status !==
        JobUserXingApplicationStatus.Undelivered
        ? userInteractions?.application?.createdAt
        : undefined,
    title,
    type: application?.__typename,
  };
};
